module.exports = __webpack_public_path__ + "assets/normal/images/ComEmpty_6.b3fff48f.png";